export default __webpack_public_path__ + "static/static-banner-img-ef7b10853f41f99a6e756a01dd11f085.jpg";